import { NgModule } from '@angular/core';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';

@NgModule({
  imports: [LottieComponent],
  providers: [
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
  ],
  exports: [LottieComponent]
})
export class SiqLottieModule { }


